import { NumberPicker } from '@formily/antd';
import { createSchemaComponent } from '../../shared';
export default createSchemaComponent({
    componentName: 'NumberPicker',
    component: NumberPicker,
});
